.kj{color:var(--gray-900);}